import type {ReactElement} from 'react';
import React from 'react';
import {Snackbar} from '@Components/snackbar';
import {SnackbarMessageGrowl} from '@Components/snackbar-message-growl';
import {EDITOR_LEFT_MARGIN, EDITOR_RIGHT_MARGIN} from '@Components/poster-editor/library/poster-editor-scrolling-library';
import {useAppSelector} from '@/hooks';
import {PosterModeType} from '@PosterWhiteboard/poster/poster-mode.class';
import {isEditorMobileVariant} from "@Components/poster-editor/library/is-editor-mobile-variant";

export function PosterEditorLoaders(): ReactElement {
  let translateXValue: number | undefined = undefined;
  const isInGeneration = useAppSelector((state) => {
    return state.posterEditor.posterObject?.mode.details.type === PosterModeType.GENERATE;
  });
  const isWebPage = useAppSelector((state) => {
    return state.posterEditor.posterObject?.mode.details.type === PosterModeType.WEB_PAGE;
  });

  if (!isEditorMobileVariant() && !isInGeneration && !isWebPage) {
    translateXValue = (EDITOR_LEFT_MARGIN - EDITOR_RIGHT_MARGIN) / 2;
  }

  return (
    <>
      <Snackbar translateXValue={translateXValue} />
      <SnackbarMessageGrowl translateXValue={translateXValue} />
    </>
  );
}
